/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterS = createReactComponent("outline", "letter-s", "IconLetterS", [["path", { "d": "M17 8a4 4 0 0 0 -4 -4h-2a4 4 0 0 0 0 8h2a4 4 0 0 1 0 8h-2a4 4 0 0 1 -4 -4", "key": "svg-0" }]]);

export { IconLetterS as default };
//# sourceMappingURL=IconLetterS.mjs.map
